import IconWrapper from './icon-wrapper';

const normalIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 5.7C3 4.20883 4.20883 3 5.7 3H7.54219C8.18809 3 8.79424 3.31193 9.16966 3.83752L9.70759 4.59062C9.80144 4.72202 9.95298 4.8 10.1145 4.8H18C19.6569 4.8 21 6.14315 21 7.8V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V5.7V5.7Z"
      stroke="#262626"
      stroke-width="2"
    />
    <path d="M12 10L12 14.75" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path d="M8.5 12V14.75" stroke="#262626" stroke-width="2" stroke-linecap="round" />
    <path d="M15.5 13.5L15.5 14.75" stroke="#262626" stroke-width="2" stroke-linecap="round" />
  </svg>
);

const activedIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 5.7C2 3.65655 3.65655 2 5.7 2H7.54219C8.51105 2 9.42026 2.4679 9.98339 3.25629L10.3718 3.8H18C20.2091 3.8 22 5.59086 22 7.8V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V5.7Z"
      fill="url(#paint0_linear_18903_5865)"
    />
    <path d="M12 10L12 14.75" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M8.5 12V14.75" stroke="white" stroke-width="2" stroke-linecap="round" />
    <path d="M15.5 13.5L15.5 14.75" stroke="white" stroke-width="2" stroke-linecap="round" />
    <defs>
      <linearGradient
        id="paint0_linear_18903_5865"
        x1="5.15789"
        y1="3.57642"
        x2="21.4467"
        y2="20.4176"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5891FF" />
        <stop offset="1" stop-color="#3768FA" />
      </linearGradient>
    </defs>
  </svg>
);

export default function IconData() {
  return <IconWrapper normalIcon={normalIcon} activedIcon={activedIcon} />;
}
